import React from 'react';
import BulmaModal from 'react-bulma-components/lib/components/modal';

import './style.scss';

const Modal = ({ children, show, onClose, closeOnBlur = false, ...props }) => (
  <BulmaModal
    show={show}
    closeOnBlur={closeOnBlur}
    onClose={onClose}
    {...props}
  >
    {children}
  </BulmaModal>
);

export { ModalCard } from './ModalCard';

export default Modal;
